import Swiper from "swiper/bundle";

const catSlider = document.querySelector(".blog-category");

if (catSlider) {
  const swiper = new Swiper(" .blog-category", {
    breakpoints: {
      0: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
      390: {
        slidesPerView: 2,
        spaceBetween: 20,
      },

      768: {
        slidesPerView: 4,
        spaceBetween: 20,
      },

      1440: {
        slidesPerView: 6,
        spaceBetween: 20,
      },
      1900: {
        slidesPerView: 7,
        spaceBetween: 24,
      },
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  });
}
